<template>
  <v-layout justify-space-between class="form-notification" :class="[params.type == 'error' ? 'form-notification-error' : 'form-notification-warning']">
    <v-layout>
      <VSvgIcon v-if="params.type =='error'" tag="24" size="24" class="icon exclamation-triangle" icon="exclamation-triangle" />
      <VSvgIcon v-if="params.type =='warning'" tag="24" size="24" class="icon exclamation-circle" icon="exclamation-circle" />
      <div v-html="params.text" class="form-notification-text"></div>
    </v-layout>
    <div class="form-notification-action" @click="actionClicked()" v-if="params.action">{{params.action.text}}</div>
  </v-layout>

</template>

<script>
  import {VSvgIcon} from "@/modules/common/components";

  export default {
    name: "FormNotification",
    components: {VSvgIcon},
    props: {
      params: {
        type: Object,
        required: true
      },
    },
    methods: {
      actionClicked() {
        this.$emit('actionClicked', this.params.action.func)
      }
    }
  };
</script>
<style lang="scss">


  .form-notification{
    width: 100%;
    height: 40px;
    font-family: var(--primary-font-family);
    color: rgba(0, 0, 0, 0.87);
    line-height: 40px;

    &.form-notification-error{
      background-color: rgba(244, 48, 64, 0.3);
    }

    &.form-notification-warning{
      background-color: rgba(255, 210, 80, 0.3);
    }

    .icon{
      width: 24px;
      height: 24px;
      margin: 10px 16px;
    }

    .form-notification-text{
      font-size: 13px;
    }

    .form-notification-action{
      font-weight: 600;
      cursor: pointer;
      margin: 0px 16px;
      font-size: 13px;
    }
  }

</style>
